<button
  (blur)="hover.set(false)"
  (click)="onClicked()"
  (focus)="hover.set(true)"
  (mouseleave)="hover.set(false)"
  (mouseover)="hover.set(true)"
  [attr.tabindex]="tabable() || globalItem() ? '0' : '-1'"
  [classList]="classes()"
  type="button"
>
  <div
    [classList]="
      navDto().level > 0
        ? 'gap-3 flex w-full items-center pl-2'
        : 'gap-3 flex justify-between'
    "
  >
    @if (canBeFavorized()) {
      <i-lucide
        [class.invisible]="!hover() && !manualActive()"
        [class]="isFavorized() ? 'fill-yellow-400' : ''"
        [img]="Star"
        (click)="toggleFavourite()"
        [color]="isFavorized() ? '#facc15' : '#a6a4a4'"
      ></i-lucide>
    }
    <i-lucide [img]="navDto().icon"></i-lucide>
    <span
      [ngClass]="{
        'text-lg': navDto().level <= 1,
        'text-sm': navDto().level > 1,
        'text-nowrap': globalItem(),
      }"
      >{{ navDto().name }}</span
    >
  </div>
</button>
@if (dropdownVisible()) {
  <ul>
    @for (child of navDto().children; track $index) {
      <li app-shell-navitem-uif [navDto]="child" [tabable]="(tabable() || globalItem()) && dropdownVisible()"></li>
    }
  </ul>
}
